module.exports = __webpack_public_path__ + "img/trumpet.069f0b1f.png";